import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar as BaseAvatar, AvatarProps as BaseAvatarProps, Tooltip, TooltipProps } from 'antd';

export interface AvatarProps extends BaseAvatarProps {
  tooltip?: React.ReactNode;
  split?: number | boolean;
  tooltipPlacement?: TooltipProps['placement'];
}

const Avatar: React.FC<AvatarProps> = ({ className, tooltip, split, icon, children, tooltipPlacement, ...props }) => {
  const content = typeof children === 'string' && split ? children.slice(0, typeof split === 'boolean' ? 2 : split) : children;
  const defaultIcon = <UserOutlined />;

  return (
    <Tooltip title={tooltip} placement={tooltipPlacement}>
      <BaseAvatar
        {...props}
        className={className}
        // eslint-disable-next-line no-nested-ternary
        icon={icon ? (typeof icon === 'boolean' ? defaultIcon : icon) : undefined}
      >
        {content}
      </BaseAvatar>
    </Tooltip>
  );
};

export default Avatar;
